import { UIText2 } from '@cian/ui-kit';
import { type TColors } from '@cian/ui-kit-design-tokens/colors';

import { type FC } from 'react';

import { WrapElementsSpacer } from 'shared/components/WrapElementsSpacer';
import { type RemotenessTypes } from 'shared/types/RemotenessTypes';
import { type TransportTypes } from 'shared/types/TransportTypes';

import { RemotenessIcon } from './internal/components/RemotenessIcon';
import { TransportIcon } from './internal/components/TransportIcon';

export type TransportProps = {
  name: string;
  iconColor: string | null;
  remoteness: string | null;
  remotenessType: RemotenessTypes | null;
  /**
   * @description Цвет иконки транспорта
   * @default icon-secondary-default
   */
  remotenessIconColor?: TColors;
  /**
   * @description Цвет текста
   * @default text-inverted-default
   */
  textColor?: TColors;
  iconType: TransportTypes | null;
};

export const Transport: FC<TransportProps> = props => {
  const {
    iconColor,
    name,
    remoteness,
    iconType,
    remotenessType,
    remotenessIconColor = 'icon-secondary-default',
    textColor = 'text-primary-default',
  } = props;

  return (
    <WrapElementsSpacer containerTestId="transport" horizontalSpace={16} verticalSpace={0}>
      <WrapElementsSpacer containerTestId="transport-name" horizontalSpace={8} verticalSpace={0} wrapItems={false}>
        {!!iconType && <TransportIcon iconColor={iconColor} iconType={iconType} />}
        <UIText2 color={textColor} data-testid="transport-name-text" display="inline">
          {name}
        </UIText2>
      </WrapElementsSpacer>
      <WrapElementsSpacer
        containerTestId="transport-remoteness"
        horizontalSpace={8}
        verticalSpace={0}
        wrapItems={false}
      >
        {!!remotenessType && <RemotenessIcon iconColor={`var(--${remotenessIconColor})`} iconType={remotenessType} />}
        <UIText2 color={textColor} data-testid="transport-remoteness-text" display="inline">
          {remoteness}
        </UIText2>
      </WrapElementsSpacer>
    </WrapElementsSpacer>
  );
};
